import { Card, ScrollArea, Stack, Text } from '@mantine/core';
import type { Message as MessageType } from '../types/message.types';
import { ChatMessage } from './Message';

export interface ChatBodyProps {
  messages: MessageType[];
  emptyStateMessage?: string;
}

export function ChatBody({
  messages,
  emptyStateMessage = 'Send a message to start the conversation!',
}: ChatBodyProps) {
  return (
    <Card.Section withBorder p="md" style={{ flexGrow: 1 }}>
      <ScrollArea offsetScrollbars>
        <Stack w="100%">
          {messages.length === 0 ? (
            <Text ta="center" c="dimmed" pt={50}>
              {emptyStateMessage}
            </Text>
          ) : (
            messages.map((message) => (
              <ChatMessage
                key={message.id}
                content={message.content}
                sender={message.sender}
                timestamp={message.timestamp}
                messageType={message.messageType}
                deliveryStatus={message.deliveryStatus}
              />
            ))
          )}
        </Stack>
      </ScrollArea>
    </Card.Section>
  );
}
